var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-vn",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vn-a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-85.3 0h682.6v512H-85.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#vn-a)",
    transform: "translate(80)scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#da251d",
    d: "M-128 0h768v512h-768z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M349.6 381 260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVn);
export default __webpack_public_path__ + "static/media/vn.e80173a9c3cbaa60c5937fb87b9dcb3f.svg";
export { ForwardRef as ReactComponent };